module.exports = __webpack_public_path__ + "img/Image 9.3b13bd08.png";